import * as React from "react";
import { RotateCcw } from "lucide-react";
import { toast } from "react-toastify";
import { useRetryBusinessReportOutcomeResultMutation } from "@/modules/snapshots/businessReports.api";

interface Props {
  businessReportOutcomeResultId: string;
  businessReportOutcomeId: string;
  setIsProcessing: (isProcessing: boolean) => void;
}

export const BusinessReportOutcomeRowRetry: React.FC<Props> = ({
  businessReportOutcomeResultId,
  businessReportOutcomeId,
  setIsProcessing,
}) => {
  const [retryBusinessReportOutcomeResult, { isLoading }] = useRetryBusinessReportOutcomeResultMutation();

  React.useEffect(() => {
    setIsProcessing(isLoading);
  }, [isLoading, setIsProcessing]);

  const handleRetry = () => {
    try {
      retryBusinessReportOutcomeResult({
        resultId: businessReportOutcomeResultId,
        id: businessReportOutcomeId,
      }).unwrap();
    } catch (error) {
      toast.error("Error while retrying");
      console.error(error);
    }
  };
  return (
    <div onClick={handleRetry} className="ml-2 cursor-pointer">
      <RotateCcw className="h-3 w-3" />
    </div>
  );
};
